import React from 'react'
import { addMinutes, differenceInMinutes, format } from 'date-fns'
import { useTheme } from '@chakra-ui/react'
import { Box, Text } from '@chakra-ui/react'

import {
    ClinicianFieldsFragment,
    AppointmentFieldsFragment,
} from '~graphql/generated/graphql'

type OpenSlot = {
    start_time: number
    minutes: number
    clinician: ClinicianFieldsFragment
}

export const OpenSlotItem: React.FC<{
    slot: OpenSlot
    startTime: number
    index: number
    spacing?: number
}> = ({ slot, startTime, index, spacing = 56 }) => {
    const theme = useTheme()

    const startDate = new Date(slot.start_time)
    const endDate = new Date(addMinutes(slot.start_time, slot.minutes))

    const bg = `rgba(180, 248, 215, 0.7)`
    const color = `rgba(0, 0, 0, 0.8)`

    const startHours = startDate.getHours()
    const startMinutes = startDate.getMinutes()

    const top =
        ((startHours - Math.floor(startTime)) * 4 + startMinutes / 15) *
        spacing +
        2

    const MIN_HEIGHT = 60
    const height = (differenceInMinutes(endDate, startDate) * spacing) / 15 - 3

    return (
        <Box
            key={'appt' + index}
            position="absolute"
            top={`${top}px`}
            left={0}
            w="100%"
            px={1}
            role="group"
            transition="0.1s"
            zIndex={0}
        >
            <Box
                bgColor={bg}
                w="full"
                opacity={0.6}
                // minH={`${24}px`}
                height={`${height}px`}
                overflow="hidden"
                _hover={{ maxH: '100%', zIndex: 1 }}
                rounded="md"
                textAlign="left"
            >
                <Box pt={height > MIN_HEIGHT ? 2 : 1} px={4} pb={3}>
                    <Text
                        color={color}
                        letterSpacing="wide"
                        fontWeight="bold"
                        fontSize={height > MIN_HEIGHT ? '14px' : '12px'}
                        lineHeight={'17px'}
                    >
                        Open Slot
                    </Text>
                    <Text color={color} fontSize="13px" fontWeight="semibold">
                        {format(startDate, 'h:mm a')} -{' '}
                        {format(endDate, 'h:mm a')}
                    </Text>
                </Box>
            </Box>
        </Box>
    )
}
